export default "/static/images/build_base_2.png?ae491d12e4066e8ee6e8abe3988665f5";